export default [
    {
        aggregation: {
            unit: 'Day',
            size: 1,
            spec: 'None',
            isContractVolume: true
        },
        label: 'Daily'
    },
    {
        aggregation: {
            unit: 'Day',
            size: 1,
            spec: 'Nearest',
            isContractVolume: false
        },
        label: 'Daily Nearest'
    },
    {
        aggregation: {
            unit: 'Week',
            size: 1,
            spec: 'None',
            isContractVolume: true
        },
        label: 'Weekly'
    },
    {
        aggregation: {
            unit: 'Week',
            size: 1,
            spec: 'Nearest',
            isContractVolume: false
        },
        label: 'Weekly Nearest'
    },
    {
        aggregation: {
            unit: 'Month',
            size: 1,
            spec: 'None',
            isContractVolume: true
        },
        label: 'Monthly'
    },
    {
        aggregation: {
            unit: 'Month',
            size: 1,
            spec: 'Nearest',
            isContractVolume: false
        },
        label: 'Monthly Nearest'
    },
    {
        aggregation: {
            unit: 'Intraday',
            size: 30,
            spec: 'None',
            isContractVolume: true
        },
        label: '30 Minutes'
    },
    {
        aggregation: {
            unit: 'Intraday',
            size: 60,
            spec: 'None',
            isContractVolume: true
        },
        label: '60 Minutes'
    },
    {
        aggregation: {
            unit: 'Intraday',
            size: 240,
            spec: 'None',
            isContractVolume: true
        },
        label: '240 Minutes'
    },
];
